export const WIDGETS = [
  ["leave_balance", "Saldo ferie"],
  ["permission_balance", "Saldo permessi"],
  ["pending_requests", "Richieste in attesa"],
  ["unread_announcements", "Comunicazioni da leggere"],
  ["announcements", "Ultime comunicazioni"],
  ["polls", "Sondaggi da votare"],
  ["meetings", "Prossimi incontri"],
];
